
import { defineComponent, ref, inject, computed, provide, nextTick } from 'vue'
import FormService from '@/core/services/FormService'
import { errManager, DownloadFile, mbtoa, showNotification } from "@/core/config/Tools";
import DialogForms from '@/views/tournaments/pages/DialogForms.vue';
import { useI18n } from "vue-i18n/index";
import Swal from 'sweetalert2';
import GlobalService from '@/core/services/GlobalService';
import { TableInstance } from 'element-plus';

export default defineComponent({
    name: "acrd-dialog-resumen-f2",
    props: {
        listStatus: {
            type: null,
            required: true,
            default: []
        },
        itemForm: {
            type: null,
            required: true,
            default: {}
        }
    },
    components: { DialogForms },
    setup(props) {
        const { t } = useI18n();
        const altura = screen.height;
        const loading = ref(false);
        const dialogResF2 = inject("dialogResF2");
        const tabName = ref('first');
        const search = ref("");
        const listInstitutions = ref<any>([])
        const dialogForm = ref(false);
        const idinstitution = ref<any>("");
        const REPO = ref<any>(process.env.VUE_APP_REPO);
        const indexRow = ref(0);
        const singleTableRef = ref<TableInstance>()

        provide("dialogForm", dialogForm)
        provide("idinstitution", idinstitution)


        const onOpened = () => {
            getListInstitutions();
        }

        const onClosed = () => {
            //listInstitutions.value = []
            //listSports.value = []
        }

        const getListInstitutions = async () => {
            loading.value = true
            await FormService.options('institutions', props.itemForm)
                .then(async(res) => {
                    listInstitutions.value = res.data.clubs
                    loading.value = false
                    await nextTick();

                    const row = listInstitutions.value[indexRow.value];
                    if (row) {
                        singleTableRef.value?.setCurrentRow(row);
                    }

                }).catch(({ response }) => {
                    loading.value = false
                    errManager(response)
                })
        }

        const filteredClubs = computed(() => {
            const query = search.value.toLowerCase();
            return listInstitutions.value.filter(
                item => {
                    const abrevMatches = item.abrev ? item.abrev.toLowerCase().includes(query) : false;
                    const businessMatches = item.business.toLowerCase().includes(query);
                    return abrevMatches || businessMatches;
                }
            );
        });

        const openDialogForm = (data, index) => {
            dialogForm.value = true;
            idinstitution.value = data;
            indexRow.value = index;
        };

        const modalClosed = () => {
            getListInstitutions()
        };

        const handlerDeleteRecord = (row: any) => {
            Swal.fire({
                title: t('deleteRecord'),
                html: t('deleteText', {text: row?.business }),
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: t('delete'),
                cancelButtonText: t('cancel'),
                reverseButtons: true,
                showLoaderOnConfirm: true,
                customClass: {
                    confirmButton: 'btn btn-sm bg-danger', // Rojo para eliminar
                    cancelButton: 'btn btn-sm bg-secondary text-black' // Gris para cancelar
                },
                preConfirm: () => {
                    return GlobalService.delete('forms', `${props.itemForm?.idform}/${row.id}`)
                        .then((res) => {
                            return res.data
                        }).catch(({ response }) => {
                            Swal.showValidationMessage(
                                `Request failed: ${response.data}`
                            )
                        })
                },
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    showNotification({ status: result.value.status, title: result.value.title, message: result.value.message })
                    result.value.status === 'success' && getListInstitutions();
                }
            })
        }

        return {
            t,
            REPO,
            altura,
            search,
            loading,
            dialogResF2,
            tabName,
            listInstitutions,
            singleTableRef,
            //events
            onOpened,
            onClosed,
            getListInstitutions,
            filteredClubs,
            openDialogForm,
            modalClosed,
            DownloadFile,
            mbtoa,
            handlerDeleteRecord

        }

    },
})
